module.exports = __webpack_public_path__ + "img/hero-mobile.a22d0845.jpg";